// extracted by mini-css-extract-plugin
export var actions = "_1h-0";
export var actionsContainer = "_1h-6";
export var border = "_1h-1";
export var childFullHeight = "_1h-d";
export var collapse = "_1h-2";
export var content = "_1h-8";
export var contentChild = "_1h-c";
export var fullscreen = "_1h-a";
export var headerContainer = "_1h-3";
export var headerRow = "_1h-5";
export var hidePadding = "_1h-9";
export var noScrollX = "_1h-e";
export var noScrollY = "_1h-f";
export var optOutTopPadding = "_1h-b";
export var pagePadding = "_1h-7";
export var profile = "_1h-g";
export var profileContainer = "_1h-h";
export var profileImage = "_1h-i";
export var profileMain = "_1h-j";
export var profileSubtitle = "_1h-l";
export var profileTitle = "_1h-k";
export var tabsWrapper = "_1h-4";
export var title = "_1h-m";